var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SheetRowPath, getSearchNumberColumnsData } from '../../data/sheetRow/sheetRow';
import { useSheetRowsSearch } from '../../data/sheetRow/sheetRowActions';
import { getTagLongName } from '../../data/tag/tagUtil';
import { TagNameDisplay } from '../../data/types';
import { useSheetRowsById } from '../../data/sheetRow/sheetRowHooks';
export function useFinder(sheetRowPath, dependencies, expressions, withDataMap) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var _e, _f, _g, _h;
    var tagMap = dependencies.tagMap, sheetRowMap = dependencies.sheetRowMap;
    var rowsById = useSheetRowsById();
    var numberColumnsDataById = new Map();
    var targetSheetRow = rowsById[sheetRowPath.sheetRowId];
    while (targetSheetRow) {
        var numberColumnsData = getSearchNumberColumnsData(targetSheetRow);
        numberColumnsDataById.set(targetSheetRow.id, numberColumnsData);
        targetSheetRow = rowsById[(_e = targetSheetRow.parentId) !== null && _e !== void 0 ? _e : 0];
    }
    var sheetRowQueries = [];
    try {
        for (var _j = __values(sheetRowPath.segments), _k = _j.next(); !_k.done; _k = _j.next()) {
            var seg = _k.value;
            sheetRowQueries.push({
                path: seg.fullPath,
                numberColumnsData: numberColumnsDataById.get(seg.sheetRowId),
                withDataChildren: withDataMap === null || withDataMap === void 0 ? void 0 : withDataMap.get(seg.sheetRowId),
                withDataCompoundExpression: expressions === null || expressions === void 0 ? void 0 : expressions.withDataCompoundExpression,
                filterCompoundExpression: expressions === null || expressions === void 0 ? void 0 : expressions.filterCompoundExpression,
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_k && !_k.done && (_a = _j.return)) _a.call(_j);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var sheetRowsResults = useSheetRowsSearch(sheetRowQueries);
    var columns = sheetRowsResults.map(function (r) { return r.data; });
    var result = [];
    try {
        for (var _l = __values(__spreadArray([], __read(columns), false)), _m = _l.next(); !_m.done; _m = _l.next()) {
            var column = _m.value;
            if (!column) {
                continue;
            }
            var columnSheetRowPath = new SheetRowPath(column.path);
            var finderColumn = {
                clusterId: columnSheetRowPath.sheetRowId,
                path: column.path,
                items: [],
            };
            try {
                for (var _o = (e_3 = void 0, __values(column.children)), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var child = _p.value;
                    var sheetRow = sheetRowMap[child.id];
                    if (!sheetRow) {
                        continue;
                    }
                    if (child.tableTagId === null) {
                        finderColumn.items.push({
                            clusterId: child.id,
                            id: child.id,
                            isActive: sheetRowPath.includes(child.path),
                            isGenerated: false,
                            label: child.name,
                            order: (_f = child.order) !== null && _f !== void 0 ? _f : 0,
                            path: child.path,
                            hasChildren: child.hasChildren,
                        });
                        continue;
                    }
                    if (!child.generated.length) {
                        finderColumn.items.push({
                            clusterId: child.id,
                            id: child.id,
                            isActive: sheetRowPath.includes(child.path),
                            isGenerated: false,
                            label: 'No result',
                            order: (_g = child.order) !== null && _g !== void 0 ? _g : 0,
                            path: child.path,
                            hasChildren: false,
                        });
                        continue;
                    }
                    try {
                        for (var _q = (e_4 = void 0, __values(child.generated)), _r = _q.next(); !_r.done; _r = _q.next()) {
                            var tagId = _r.value;
                            var tag = tagMap[tagId];
                            if (!tag) {
                                continue;
                            }
                            var generatedPath = child.path + ':' + tag.id;
                            finderColumn.items.push({
                                path: generatedPath,
                                clusterId: child.id,
                                id: tag.id,
                                isActive: sheetRowPath.includes(generatedPath),
                                isGenerated: true,
                                label: getTagLongName(tag, TagNameDisplay.Both),
                                order: (_h = child.order) !== null && _h !== void 0 ? _h : 0,
                                hasChildren: child.hasChildren,
                                parentTagId: tag.ParentId,
                                tagId: tag.id,
                            });
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_r && !_r.done && (_d = _q.return)) _d.call(_q);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_c = _o.return)) _c.call(_o);
                }
                finally { if (e_3) throw e_3.error; }
            }
            result.push(finderColumn);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_m && !_m.done && (_b = _l.return)) _b.call(_l);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return result;
}
